<div class="align-center" *ngIf="enable_modal">
  <div class="overlay" [@background] *ngIf="modal.is_active" (click)="close()"></div>
  <div class="modal" [@dialog] *ngIf="modal.is_active" style="max-width: 400px;">
    <div class="modal">
      <div class="modal-header">
        <div class="modal-header-txt">Edit Arming Configuration</div>
        <div style="position:relative">
          <div class="title-close"><i class="material-icons" (click)="close()">close</i></div>
        </div>
      </div>
      <div class="items-area">
        <div class="item row" style="padding-bottom:10px;">
          <div class="v-center">Arming Source</div>
          <div class="tooltip-content v-center"><i class="material-icons-outlined tooltip-icon">info</i>
            <div class="tooltip">
              <div class="tooltip-title">Alarm Panel Pairing</div>
              <div class="tooltip-label">Individual Bridge Voltage Arming</div>
              <div class="tooltip-content">The Bridges are armed and disarmed based on a voltage change using the wiring with the on-site alarm panel. This pairing method allows Bridges to follow the armed and disarmed state of an alarm panel using the programmable output or PGMs of the alarm panel. Settings and voltage values for each Bridge are programmed on the Bridge settings. Information on how to program and wire various alarm panels with the Bridge is available on our KB site. docs.chekt.com<a class="link" href="https://support.chekt.com/portal/en/kb/chekt" target="_blank">docs.chekt.com</a></div>
              <div class="tooltip-label">Primary Bridge Voltage Arming</div>
              <div class="tooltip-content">The Primary Bridge of a site is armed and disarmed based on the voltage change. All other Bridges of the site will follow the armed state of the Primary Bridge. The Primary Bridge is the frist Bridge of a site, typically Bridge 901.</div>
              <div class="tooltip-title pt-20">CHeKT Video Security System</div>
              <div class="tooltip-content">CHeKT"s stand-alone Video Security System setup allows integrators to use the Bridge as an independent video security system. All Bridges on the site are armed and disarmed from the end-user app or the CHeKT dealer portal. With this method, the Bridges do not need a traditional alarm panel on site for arming, and should be programmed to communicate alarm and video events to an alarm monitoring center.</div>
            </div>
          </div>
        </div>
        <c-alert
          *ngIf="disableAlarmPanelPairing"
          severity="warning"
          title="Alarm Panel Pairing unavailable — "
          style="margin-bottom: 8px;"
        >
          No Bridge has an Arming Digital Input.
        </c-alert>
        <div class="item row">
          <select class="inner-selectbox" [(ngModel)]="selArmingSource" (change)="setArmingSource()">
            <option *ngFor="let armingSource of siteArmingSources"
                    [ngValue]="armingSource"
                    [disabled]="armingSource.value === 2 && disableAlarmPanelPairing">
              {{armingSource.name}}
            </option>
          </select>
        </div>
        <div class="item" *ngIf="selArmingSource?.value === 3" style="padding-bottom: 7px;" [class.disabled]="!isExistBridge">
          <div class="title" style="margin-bottom: 0px;">Entry Delay</div>
          <div class="flex" [class.disabled]="isLoading">
            <div class="flex" style="align-items: center;">
              <input autocomplete="off" type="number" min="0" max="900" [(ngModel)]="selBridge.entry_delay" style="width: 65px;"/><span class="after-label">Sec</span>
            </div>
            <div class="value-slider">
              <ngx-slider [(value)]="selBridge.entry_delay" [options]="sliderOption"></ngx-slider>
            </div>
          </div>
        </div>
        <div class="item" *ngIf="selArmingSource?.value === 3" style="padding-bottom: 7px;" [class.disabled]="!isExistBridge">
          <div class="title" style="margin-bottom: 0px;">Exit Delay</div>
          <div class="flex" [class.disabled]="isLoading">
            <div class="flex" style="align-items: center;">
              <input autocomplete="off" type="number" min="0" max="300" [(ngModel)]="selBridge.exit_delay" style="width: 65px;"/><span class="after-label">Sec</span>
            </div>
            <div class="value-slider">
              <ngx-slider [(value)]="selBridge.exit_delay" [options]="sliderOption"></ngx-slider>
            </div>
          </div>
        </div>
        <div class="item" *ngIf="selArmingSource?.value === 3" style="padding-bottom: 7px;" [class.disabled]="!isExistBridge">
          <div class="title" style="margin-bottom: 0px;">Bell Duration</div>
          <div class="flex" [class.disabled]="isLoading">
            <div class="flex" style="align-items: center;">
              <input autocomplete="off" type="number" min="1" max="60" [(ngModel)]="selBridge.bellDurationMin" style="width: 65px;" (input)="setBellDuration()"/><span class="after-label">Min</span>
            </div>
            <div class="value-slider">
              <ngx-slider [(value)]="selBridge.bellDurationMin" [options]="bellSliderOption" (userChange)="setBellDuration()"></ngx-slider>
            </div>
          </div>
        </div>
        <div class="item" *ngIf="selArmingSource?.value === 2" style="padding-bottom:10px;">
          <div class="v-center">Arming Method</div>
        </div>
        <c-alert
          *ngIf="selArmingSource?.value === 2 && disableIndividualArming"
          severity="warning"
          title="Individual Bridge Voltage Arming unavailable — "
          style="margin-bottom: 8px;"
        >
          One or more Bridges do not have an Arming Digital Input.
        </c-alert>
        <div class="item" *ngIf="selArmingSource?.value === 2">
          <select class="inner-selectbox mb-5" [(ngModel)]="selArmingMethod" (change)="setArmingMethod()">
            <option *ngFor="let armingMethod of siteArmingMethods"
                    [ngValue]="armingMethod"
                    [disabled]="armingMethod.value === 0 && disableIndividualArming">
              {{armingMethod.name}}
            </option>
          </select>
          <ng-container *ngIf="selArmingMethod?.value === 1">
            <div class="title" style="margin-top: 8px; margin-bottom: 4px;">Primary Bridge</div>
            <select class="inner-selectbox mb-5"
                    [(ngModel)]="selBridge"
                    [compareWith]="compareBridges">
              <option *ngFor="let b of bridges"
                      [ngValue]="b"
                      [disabled]="!bridgeArmingDIMap.get(b.device_id)">
                {{b.name || b.device_id}} ({{b.virtual_zone}})<span *ngIf="!bridgeArmingDIMap.get(b.device_id)"> - No Arming DI</span>
              </option>
            </select>
          </ng-container>
        </div>
        <div class="item" *ngIf="selArmingSource?.value === 2">
          <div class="title">Arming Type</div>
          <div class="sub-item" [ngClass]="{'sub-item-selected': armingType == 0 && armTrigger =='no'}" style="padding-top:0" (click)="selectArmingType(0, 'no')">
            <div class="radio-btn"><i class="material-icons radio-selected" *ngIf="armingType === 0 && armTrigger ==='no'; else unselected">radio_button_checked</i>
              <ng-template #unselected><i class="material-icons">radio_button_unchecked</i></ng-template>
            </div>
            <div class="contents"><span>High Voltage Arming</span></div>
          </div>
          <div class="sub-item" [ngClass]="{'sub-item-selected': armingType == 0 && armTrigger =='nc'}" (click)="selectArmingType(0, 'nc')">
            <div class="radio-btn"><i class="material-icons radio-selected" *ngIf="armingType === 0 && armTrigger ==='nc'; else unselected">radio_button_checked</i>
              <ng-template #unselected><i class="material-icons">radio_button_unchecked</i></ng-template>
            </div>
            <div class="contents"><span>Low Voltage Arming</span></div>
          </div>
          <div class="sub-item" [ngClass]="{'sub-item-selected': armingType == 1}" (click)="selectArmingType(1)">
            <div class="radio-btn"><i class="material-icons radio-selected" *ngIf="armingType === 1; else unselected">radio_button_checked</i>
              <ng-template #unselected><i class="material-icons">radio_button_unchecked</i></ng-template>
            </div>
            <div class="contents">Always Armed</div>
          </div>
          <div class="sub-item" [ngClass]="{'sub-item-selected': armingType == 2}" (click)="selectArmingType(2)">
            <div class="radio-btn"><i class="material-icons radio-selected" *ngIf="armingType === 2; else unselected">radio_button_checked</i>
              <ng-template #unselected><i class="material-icons">radio_button_unchecked</i></ng-template>
            </div>
            <div class="contents">Always Disarmed</div>
          </div>
        </div>
      </div>
      <div class="tail-btn-area">
        <div class="button button-primary" (click)="update()">
          <div class="btn-inner">Change All Bridges</div>
        </div>
        <div class="button" (click)="close()">
          <div class="btn-inner">Cancel</div>
        </div>
      </div>
      <div class="loader absolute" *ngIf="isLoading">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
        </svg>
      </div>
    </div>
  </div>
</div>
<dealer-warning [modal]="m_warning"></dealer-warning>
